module.exports = __webpack_public_path__ + "img/pic_action_icon@2x.e6c0a355.png";